const siteHeader = document.querySelector('.site-header');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.classList.add('visible');
      }, i * 60);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

// Header scroll shrink
let lastScroll = 0;
window.addEventListener('scroll', () => {
  const scrollY = window.scrollY;
  if (scrollY > 60) {
    siteHeader.classList.add('scrolled');
  } else {
    siteHeader.classList.remove('scrolled');
  }
  lastScroll = scrollY;
}, { passive: true });

// Tab interactivity
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// Mega menu hover
const cardsToggle = document.getElementById('cardsToggle');
const megaMenu = document.getElementById('megaMenu');
let megaTimeout;

function positionMegaMenu() {
  const headerRect = siteHeader.getBoundingClientRect();
  megaMenu.style.top = headerRect.bottom + 'px';
}

function openMega() {
  clearTimeout(megaTimeout);
  cardsToggle.classList.add('mega-open');
  megaMenu.classList.add('open');
  positionMegaMenu();
}

function closeMega() {
  megaTimeout = setTimeout(() => {
    cardsToggle.classList.remove('mega-open');
    megaMenu.classList.remove('open');
  }, 200);
}

cardsToggle.addEventListener('mouseenter', openMega);
cardsToggle.addEventListener('mouseleave', closeMega);
megaMenu.addEventListener('mouseenter', () => clearTimeout(megaTimeout));
megaMenu.addEventListener('mouseleave', closeMega);

// Also support click for touch devices
cardsToggle.addEventListener('click', (e) => {
  e.stopPropagation();
  if (megaMenu.classList.contains('open')) {
    cardsToggle.classList.remove('mega-open');
    megaMenu.classList.remove('open');
  } else {
    openMega();
  }
});

window.addEventListener('scroll', () => {
  if (megaMenu.classList.contains('open')) positionMegaMenu();
}, { passive: true });

document.addEventListener('click', (e) => {
  if (!megaMenu.contains(e.target) && !cardsToggle.contains(e.target)) {
    cardsToggle.classList.remove('mega-open');
    megaMenu.classList.remove('open');
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && megaMenu.classList.contains('open')) {
    cardsToggle.classList.remove('mega-open');
    megaMenu.classList.remove('open');
  }
});

megaMenu.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    cardsToggle.classList.remove('mega-open');
    megaMenu.classList.remove('open');
  });
});

// Featured mega-menu rotator -- cycles through the top N most expensive
// in-stock products (rendered server-side in header.liquid) at the
// interval set on the Mega Menu Featured block in the theme customizer.
document.querySelectorAll('.mega-featured-rotator').forEach((rotator) => {
  const items = rotator.querySelectorAll('.mega-featured-rotate-item');
  if (items.length < 2) return;

  const interval = parseInt(rotator.dataset.interval, 10) || 5000;
  let current = 0;

  setInterval(() => {
    items[current].classList.remove('active');
    current = (current + 1) % items.length;
    items[current].classList.add('active');
  }, interval);
});

// Light / dark theme toggle
// (initial theme is applied in theme.liquid's <head> via a small inline
// script, before this file loads, to avoid a flash of the wrong theme)
const themeToggle = document.getElementById('themeToggle');
if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    const root = document.documentElement;
    const isLight = root.getAttribute('data-theme') === 'light';
    if (isLight) {
      root.removeAttribute('data-theme');
      localStorage.setItem('hns-theme', 'dark');
    } else {
      root.setAttribute('data-theme', 'light');
      localStorage.setItem('hns-theme', 'light');
    }
  });
}

// Fullscreen menu toggle
const menuToggle = document.getElementById('menuToggle');
const fullscreenMenu = document.getElementById('fullscreenMenu');

menuToggle.addEventListener('click', () => {
  menuToggle.classList.toggle('active');
  fullscreenMenu.classList.toggle('open');
  document.body.classList.toggle('menu-open');
});

// Close menu when clicking a nav link
fullscreenMenu.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    menuToggle.classList.remove('active');
    fullscreenMenu.classList.remove('open');
    document.body.classList.remove('menu-open');
  });
});

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && fullscreenMenu.classList.contains('open')) {
    menuToggle.classList.remove('active');
    fullscreenMenu.classList.remove('open');
    document.body.classList.remove('menu-open');
  }
});

// ============================================
// FILTER BAR DROPDOWNS (Availability, Price, etc.)
// ============================================
document.querySelectorAll('[data-filter-group]').forEach((group) => {
  const toggle = group.querySelector('[data-filter-toggle]');
  if (!toggle) return;

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = group.classList.contains('filter-group--open');

    // Close any other open filter dropdowns in the same bar
    const bar = group.closest('#filterBar');
    if (bar) {
      bar.querySelectorAll('.filter-group--open').forEach((openGroup) => {
        if (openGroup !== group) openGroup.classList.remove('filter-group--open');
      });
    }

    group.classList.toggle('filter-group--open', !isOpen);
  });
});

// Close filter dropdowns when clicking outside
document.addEventListener('click', (e) => {
  document.querySelectorAll('.filter-group--open').forEach((group) => {
    if (!group.contains(e.target)) group.classList.remove('filter-group--open');
  });
});

// Close filter dropdowns on Escape
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.filter-group--open').forEach((group) => {
      group.classList.remove('filter-group--open');
    });
  }
});

// ============================================
// FILTER SIDEBAR — accordion sections + mobile drawer
// ============================================
document.querySelectorAll('[data-fs-section]').forEach((section, i) => {
  const toggle = section.querySelector('[data-fs-toggle]');
  if (!toggle) return;
  // Default open, matching the reference layout
  section.classList.add('fs-section--open');

  toggle.addEventListener('click', () => {
    section.classList.toggle('fs-section--open');
  });
});

const fsSidebar = document.getElementById('filterSidebar');
const fsOverlay = document.querySelector('[data-fs-overlay]');
const fsOpenBtn = document.querySelector('[data-fs-open]');
const fsCloseBtn = document.querySelector('[data-fs-close]');

function fsOpenSidebar() {
  if (!fsSidebar) return;
  fsSidebar.classList.add('fs-open');
  if (fsOverlay) fsOverlay.classList.add('fs-open');
  document.body.classList.add('menu-open');
}

function fsCloseSidebar() {
  if (!fsSidebar) return;
  fsSidebar.classList.remove('fs-open');
  if (fsOverlay) fsOverlay.classList.remove('fs-open');
  document.body.classList.remove('menu-open');
}

if (fsOpenBtn) fsOpenBtn.addEventListener('click', fsOpenSidebar);
if (fsCloseBtn) fsCloseBtn.addEventListener('click', fsCloseSidebar);
if (fsOverlay) fsOverlay.addEventListener('click', fsCloseSidebar);

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && fsSidebar && fsSidebar.classList.contains('fs-open')) {
    fsCloseSidebar();
  }
});

// ============================================
// PRICE RANGE SLIDER
// ============================================
document.querySelectorAll('[data-fs-price-slider]').forEach((slider) => {
  const max = parseFloat(slider.dataset.max) || 100;
  const minRange = slider.querySelector('[data-fs-price-range="min"]');
  const maxRange = slider.querySelector('[data-fs-price-range="max"]');
  const fill = slider.querySelector('[data-fs-price-fill]');
  if (!minRange || !maxRange || !fill) return;

  const body = slider.closest('.fs-section-body');
  const minNumber = body ? body.querySelector('[data-fs-price-number="min"]') : null;
  const maxNumber = body ? body.querySelector('[data-fs-price-number="max"]') : null;

  function updateFill() {
    const minVal = parseFloat(minRange.value);
    const maxVal = parseFloat(maxRange.value);
    const minPct = max > 0 ? (minVal / max) * 100 : 0;
    const maxPct = max > 0 ? (maxVal / max) * 100 : 100;
    fill.style.left = minPct + '%';
    fill.style.right = (100 - maxPct) + '%';
  }

  minRange.addEventListener('input', () => {
    if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
      minRange.value = maxRange.value;
    }
    if (minNumber) minNumber.value = minRange.value;
    updateFill();
  });

  maxRange.addEventListener('input', () => {
    if (parseFloat(maxRange.value) < parseFloat(minRange.value)) {
      maxRange.value = minRange.value;
    }
    if (maxNumber) {
      // At the cap ($10,000+), leave the number field blank so the
      // filter submits with no upper bound, instead of literally
      // limiting results to <= $10,000.
      if (parseFloat(maxRange.value) >= max) {
        maxNumber.value = '';
      } else {
        maxNumber.value = maxRange.value;
      }
    }
    updateFill();
  });

  if (minNumber) {
    minNumber.addEventListener('input', () => {
      let v = parseFloat(minNumber.value);
      if (isNaN(v)) v = 1;
      if (v > parseFloat(maxRange.value)) v = parseFloat(maxRange.value);
      minRange.value = v;
      updateFill();
    });
  }

  if (maxNumber) {
    maxNumber.addEventListener('input', () => {
      let v = parseFloat(maxNumber.value);
      if (isNaN(v)) v = max;
      if (v < parseFloat(minRange.value)) v = parseFloat(minRange.value);
      maxRange.value = v;
      updateFill();
    });
  }

  updateFill();
});

// ============================================
// FILTER SIDEBAR CHECKBOXES — auto-submit the shared form on change
// ============================================
document.querySelectorAll('[data-fs-auto-submit]').forEach((input) => {
  input.addEventListener('change', () => {
    const form = input.closest('form');
    if (form) form.submit();
  });
});

// ============================================
// SETS: search filter + load more (10 at a time)
// ============================================
document.querySelectorAll('[data-fs-set-search]').forEach((searchInput) => {
  const body = searchInput.closest('.fs-section-body');
  if (!body) return;
  const optionsContainer = body.querySelector('[data-fs-set-options]');
  const loadMoreBtn = body.querySelector('[data-fs-load-more]');
  if (!optionsContainer) return;
  const items = Array.from(optionsContainer.querySelectorAll('[data-fs-set-item]'));
  const batchSize = 10;
  let visibleCount = batchSize;

  function showDefault() {
    items.forEach((item, i) => {
      item.style.display = i < visibleCount ? '' : 'none';
    });
    if (loadMoreBtn) {
      loadMoreBtn.style.display = visibleCount < items.length ? '' : 'none';
    }
  }

  showDefault();

  searchInput.addEventListener('input', () => {
    const term = searchInput.value.trim().toLowerCase();
    if (term === '') {
      showDefault();
      return;
    }
    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    items.forEach((item) => {
      const label = item.querySelector('.filter-option-label');
      const text = label ? label.textContent.toLowerCase() : '';
      item.style.display = text.includes(term) ? '' : 'none';
    });
  });

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += batchSize;
      showDefault();
    });
  }
});

// ============================================
// NAV DROPDOWNS — menu items with sub-links (e.g. "Games")
// ============================================
document.querySelectorAll('[data-nav-dropdown]').forEach((dropdown) => {
  let navDropdownTimeout;

  function openNavDropdown() {
    clearTimeout(navDropdownTimeout);
    dropdown.classList.add('nav-dropdown--open');
  }

  function closeNavDropdown() {
    navDropdownTimeout = setTimeout(() => {
      dropdown.classList.remove('nav-dropdown--open');
    }, 200);
  }

  dropdown.addEventListener('mouseenter', openNavDropdown);
  dropdown.addEventListener('mouseleave', closeNavDropdown);

  // Touch/click support
  dropdown.addEventListener('click', (e) => {
    e.stopPropagation();
    if (dropdown.classList.contains('nav-dropdown--open')) {
      dropdown.classList.remove('nav-dropdown--open');
    } else {
      openNavDropdown();
    }
  });
});

document.addEventListener('click', (e) => {
  document.querySelectorAll('.nav-dropdown--open').forEach((dropdown) => {
    if (!dropdown.contains(e.target)) dropdown.classList.remove('nav-dropdown--open');
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.nav-dropdown--open').forEach((dropdown) => {
      dropdown.classList.remove('nav-dropdown--open');
    });
  }
});

// ============================================
// POKEMON ERAS PAGE — accordion expand/collapse
// ============================================
document.querySelectorAll('[data-era-row]').forEach((row) => {
  const toggle = row.querySelector('[data-era-toggle]');
  if (!toggle) return;
  toggle.addEventListener('click', () => {
    row.classList.toggle('era-row--open');
  });
});